export function matchesBetween<T extends string>(
  arr1: T[],
  arr2: T[] | readonly T[],
) {
  const regexPatterns = arr2.map((pattern) => {
    const escapedPattern = pattern.replace(/[-[\]{}()+?.,\\^$|#\s]/g, '\\$&'); // Escape special regex characters
    return new RegExp(escapedPattern);
  });

  return arr1.some((item) => regexPatterns.some((regex) => regex.test(item)));
}
